var title = process.env.VUE_APP_TITLE;
var platformEnv = process.env.VUE_APP_PLATFORM;
import logoHider from '@/assets/logohider.png';
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      title: title,
      logoHider: logoHider,
      platformEnv: platformEnv
    };
  }
};